module.exports = __webpack_public_path__ + "static/media/event-services-img17.75068972.jpg";